import React from "react";
import { Icon, Table, TableBody, TableCell, TableHead, TableRow, makeStyles } from "@material-ui/core";
import { ConvertedNumber } from "../../../controls";
import SuggestedRouteMap from "./SuggestedRouteMap";

const styles = (theme) => ({
  titleBar: {
    color:theme.palette.secondary.contrastText, 
    backgroundColor: theme.palette.secondary.main, 
    padding: 5 , 
    cursor: "pointer",
    "& .aircraftSeparator": {
      transform: "rotate(90deg)", 
      color:theme.palette.primary.main, 
      fontSize: 10
    },
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
      color:theme.palette.primary.contrastText, 
      "& .aircraftSeparator": {
        color:theme.palette.secondary.main,
      }
    }
  }
});

const tableStyles = (theme) => ({
  PayloadMap: {
    '& .MuiTableHead-root .MuiTableRow-root': {
      backgroundColor: "#e0e0e0"
    },
    '& .MuiTableCell-root': {
      padding: 5
    }
  },
});

const routeColours = {
  leg0: {color: "rgba(77, 134, 165, 1)"},
  leg1: {color: "rgba(207, 11, 221, 1)"},
  leg2: {color: "rgba(18, 186, 181, 1)"},
  leg3: {color: "rgba(62, 81, 122, 1)"},
  leg4: {color: "rgba(122, 218, 1, 1)"},
  leg5: {color: "rgba(212, 109, 31, 1)"},
  leg6: {color: "rgba(214, 11, 45, 1)"},
  leg7: {color: "rgba(145, 146, 203, 1)"},
  leg8: {color: "rgba(136, 179, 89, 1)"},
  leg9: {color: "rgba(45, 205, 183, 1)"},
}

const routeStyles = (theme) => (routeColours);

const FlightRoute = (props) => {
  const {airports} = props;

  const classes = makeStyles(styles)();

  return (
    <>{airports.map((airport, i) => (<>{i>0?<Icon className="aircraftSeparator">local_airport</Icon>:<></>}<span>{airport}</span></>))}</>
  )
}

const PayloadMap = (props) => {
  const {airports, payloads, distances, routeClasses} = props;

  const classes = makeStyles(tableStyles)();

  const data = [];
  for (let i = 0; i < airports.length - 1; i++) {
    const record = {
      origin: airports[i],
      destination: airports[i+1],
      payload: payloads[i],
      distance: distances[i]
    }
    data.push(record);
  }

  return (
    <Table className={classes.PayloadMap}>
      <TableHead>
        <TableRow>
          <TableCell>Leg</TableCell>
          <TableCell align="right">Payload</TableCell>
          <TableCell align="right">Distance</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((record, legNo) => 
          <TableRow>
            <TableCell><Icon style={{fontSize: 12}} className={routeClasses[`leg${legNo}`]}>brightness_1</Icon>{record.origin}-{record.destination}</TableCell>
            <TableCell align="right">{record.payload}</TableCell>
            <TableCell align="right"><ConvertedNumber uom='MTR' toUom='NM' decimalScale={0} fixedDecimalScale={true} suffix=' miles' value={record.distance} /></TableCell>
          </TableRow>      
        )}
      </TableBody>
    </Table>
  )
}

const RouteOption = (props) => {
  const {option} = props;
  const {combination, points, distances, payloads, distance} = option;

  const route = combination.map((airportCode, i) => ({airportCode, ...points[i]}));
  const classes = makeStyles(styles)();
  const routeClasses = makeStyles(routeStyles)();

  return (
    <div style={{minWidth: 770, height: 300, border: "1px solid #999999", color: "#FFFFFF"}}>
      <div className={classes.titleBar} onClick={()=>props.onClick(option)}>
        <div style={{display: 'inline-block'}}>
          <FlightRoute airports={combination}/>
        </div>
        <div style={{display: 'inline-block', float: "right"}}>
          <ConvertedNumber uom='MTR' toUom='NM' decimalScale={0} fixedDecimalScale={true} suffix=' miles' value={distance} />
        </div>
      </div>
      <div style={{padding: 2}}>
        <div style={{display: 'inline-block', width: "calc(100% - 520px)", verticalAlign: "top"}}>
          <PayloadMap airports={combination} payloads={payloads} distances={distances} routeClasses={routeClasses}/>
        </div>
        <div style={{display: 'inline-block', width: 500, float: "right"}}>
          <SuggestedRouteMap record={{route}} routeColours={routeColours}/>
        </div>
      </div>
    </div>
  )
}

export default RouteOption;